"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupIdsByContentType = void 0;
var parse_resource_id_util_1 = require("./parse-resource-id.util");
function groupIdsByContentType(ids) {
    return ids.reduce(function (groups, id) {
        var parsedId = gracefullyGetPartition(id);
        if (parsedId) {
            var type = parsedId.subpartition || parsedId.partition;
            groups[type] = groups[type] || [];
            groups[type].push(id);
        }
        return groups;
    }, {});
}
exports.groupIdsByContentType = groupIdsByContentType;
function gracefullyGetPartition(id) {
    try {
        return parse_resource_id_util_1.parseResourceId(id);
    }
    catch (e) {
        return null;
    }
}
//# sourceMappingURL=group-ids-by-partition.util.js.map